import { render, staticRenderFns } from "./SignupView.vue?vue&type=template&id=21ba39b2&scoped=true&lang=pug&"
import script from "./SignupView.vue?vue&type=script&lang=js&"
export * from "./SignupView.vue?vue&type=script&lang=js&"
import style0 from "./SignupView.vue?vue&type=style&index=0&id=21ba39b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba39b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VContainer,VImg})
